module.exports = __webpack_public_path__ + "static/img/training.4e39e5f4.svg";